import React, { Component } from 'react';
import axios from 'axios';
//Custom Components
import { LabeledData } from './LabeledData';
//Bootstrap
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Carousel from 'react-bootstrap/Carousel';
//React-Datetime
import "react-datetime/css/react-datetime.css";
import "moment/locale/tr";
import moment from 'moment';
//Image Resizer
import Resizer from 'react-image-file-resizer';

export class InsuranceServiceDetail extends Component {
    static displayName = InsuranceServiceDetail.name;

    constructor(props) {
        super(props);
        this.state = {
            serviceData: {},
            photosPreview: []
        };
    }


    //Component Events
    componentDidMount() {
        this.setState({ serviceData: this.props.service.data.data }, () => {
            for (const [, value] of this.state.serviceData?.photos.entries()) {
                var dataURI = "data:image/jpeg;base64," + value.imageData;
                var byteString = atob(dataURI.split(',')[1]);
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++)
                    ia[i] = byteString.charCodeAt(i);
                var blob = new Blob([ab], { type: mimeString });
                Resizer.imageFileResizer(
                    blob,
                    600,
                    600,
                    'JPEG',
                    100,
                    0,
                    uri => {
                        const newArray = this.state.photosPreview?.concat(uri);
                        this.setState({ photosPreview: newArray });
                    }
                );
            }
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.service !== this.props.service) {
            this.setState({ serviceData: this.props.service.data.data });
        }
    }
    render() {

        return (
            <>
                <style>
                    {`
                    .tum-satir {
                      padding:2px 2px 4px 10px;       
                    }
                    .ilk-sutun {
                      //display: flex;
                      //align-items: center;

                      //width: 100px;
                      background-color: #e9ecef;
                      padding:6px 2px 6px 6px;
                      border:1px solid #ced4da;
                    }
                    .ikinci-sutun {   
                      padding:6px 2px 6px 6px;    
                      margin-right:0px;
                      border:1px solid #e9ecef;
                      background-color: #e9ecef;
                    }
                  `}
                </style>
                <Card className="mb-1">
                    <Card.Header>
                        <h6>Servis Bilgileri</h6>
                    </Card.Header>
                    <Card.Body>
                        <Row >
                            <Col xs={12}>
                                <Form.Group>
                                    <Row className="tum-satir">
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Dosya No:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.caseReferanceNumber}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Çağrı Tarihi:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun" >{this.state.serviceData.serviceCase?.callDate == null ? "" : moment(this.state.serviceData.serviceCase?.callDate).format("DD.MM.YYYY HH:mm")}</Col>
                                            </Row>
                                        </Col>
                                    </Row>


                                    <Row className="tum-satir">
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Poliçe No:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.caseProductOwner?.productPolicyNumber}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Servis:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.selectedServiceType?.description}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="tum-satir">
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Hasar Tip:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.damageDescription}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Plaka/Poliçe:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.caseProductOwner?.platePolicyNumber}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="tum-satir">
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Sigortalı:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.caseProductOwner?.name}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Arayan Kişi Ad/Soyad:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.callerName}</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="tum-satir">
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Olay Yeri Şehir:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.town?.description}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Arayan Kişi Telefonu:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.callerPhoneNumber}</Col>
                                            </Row>

                                        </Col>
                                    </Row>
                                    <Row className="tum-satir">
                                        <Col xs={12} sm={12} md={6}>
                                            <Row>
                                                <Col xs={3} className="ilk-sutun"><strong>Olay Yeri İlçe:</strong></Col>
                                                <Col xs={8} className="ikinci-sutun">{this.state.serviceData.serviceCase?.townArea?.description}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            {/*<LabeledData label="Olay Yeri Semt:" data={this.state.serviceData.serviceCase?.sceneArea} />*/}
                                        </Col>
                                    </Row>
                                    {/*<Row>*/}
                                    {/*    <Col xs={12} sm={12} md={6}>*/}
                                    {/*        <LabeledData label="Araç Marka:" data={this.state.serviceData.serviceCase?.caseProductOwner?.vehicleBrand} />*/}
                                    {/*    </Col>*/}
                                    {/*    <Col xs={12} sm={12} md={6}>*/}
                                    {/*        <LabeledData label="Araç Model:" data={this.state.serviceData.serviceCase?.caseProductOwner?.vehicleModel} />*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                    {/*<Row>*/}
                                    {/*    <Col xs={12} sm={12} md={6}>*/}
                                    {/*        <LabeledData label="Şüpheli Durum:" data={this.state.serviceData.providerIsSuspiciousSituation ? "Var" : "Yok"} />*/}
                                    {/*    </Col>*/}
                                    {/*    <Col xs={12} sm={12} md={6}>*/}
                                    {/*        <LabeledData label="Bedeni Zarar:" data={this.state.serviceData.providerIsBodilyDamage ? "Var":"Yok"} />*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className={this.state.serviceData?.photos?.length > 0 ? "" : "d-none"}>
                    <Card.Header>
                        <h6>Fotoğraflar</h6>
                    </Card.Header>
                    <Card.Body>
                        <Carousel>
                            {this.state.photosPreview?.map(item => (
                                <Carousel.Item key={item.imageData}>
                                    <div className="d-flex justify-content-center">
                                        <img src={item} alt="X" />
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </Card.Body>
                </Card>
            </>
        );
    }
}
